import React, { Component } from "react";
import { Breadcrumb, Button, Card, Form, Input, InputNumber, Modal, Upload, Select, notification } from "antd";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";

import CircularProgress from "components/CircularProgress";
import Auxiliary from "util/auxiliary";
import PageHeader from "components/PageHeader";

import {
  addHomeSlider,
  updateHomeSlider,
  resetHomeSlider
} from "./../../../appRedux/actions/homeSlider";

const FormItem = Form.Item;
const { Option } = Select;

class AddHomeSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editId: null,
      selected_type: 'Video',
      types: [{
        name: 'Picture'
      }, {
        name: 'Video'
      }],
      fileList: [],
      uploading: false,
      previewVisible: false,
      previewImage: ''
    }

    this.formRef = React.createRef();
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      const { authUser } = this.props.auth;
      const INSTANCE = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '.concat(authUser.token)
        }
      });

      let inputJSON = JSON.stringify({
        _id: this.props.match.params.id
      })

      INSTANCE.post("home-slider/get-by-id", inputJSON)
        .then((response) => {
          if (response.data.messageId === 200) {
            this.formRef.current.setFieldsValue({
              type: response.data.data.type,
              slideUrl: response.data.data.slideUrl,
              name: response.data.data.name ? response.data.data.name : "",
              seq: response.data.data.seq ? response.data.data.seq : ""
            });
            this.setState({
              editId: this.props.match.params.id
            })
          }
        })
        .catch((error) => {
        })
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.homeSlider) {
      if (nextProps.homeSlider.messageId === 200) {
        notification['success']({
          message: 'Success',
          description: nextProps.homeSlider.alertMessage
        });
        nextProps.resetHomeSlider();
      } else if (nextProps.homeSlider.messageId === 203) {
        notification['error']({
          message: 'Alert!!',
          description: nextProps.homeSlider.alertMessage
        });
        nextProps.resetHomeSlider();
      }
      return true;
    }
    return null;
  }

  onFinish = values => {
    const { authUser } = this.props.auth;
    const { editId, fileList, selected_type } = this.state;
    let inputJSON = values;
    if (selected_type === "Picture") {
      if (fileList.length === 0) {
        notification['error']({
          message: 'Alert!!',
          description: "Please select slider picture."
        });
        return;
      }
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('image', file);
      });
      formData.append('path', 'home-sliders/');
      this.setState({
        uploading: true,
      });
      const INSTANCE = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '.concat(authUser.token)
        }
      });
      INSTANCE.post('upload-file/upload', formData)
        .then((response) => {
          if (response.data.messageId === 200) {
            inputJSON.slideUrl = response.data.data.location;
            this.onFinalFinish(editId, inputJSON, authUser);
          } else {
            this.setState({
              uploading: false
            }, () => {
              notification['error']({
                message: 'Alert!!',
                description: response.data.message
              });
            });
          }
        })
        .catch((error) => {
          this.setState({
            uploading: false
          }, () => {
            notification['error']({
              message: 'Alert!!',
              description: error
            });
          });
        })
    } else {
      this.onFinalFinish(editId, inputJSON, authUser);
    }
  };

  onFinalFinish = (editId, inputJSON, authUser) => {
    if (editId) {
      inputJSON._id = editId;
      inputJSON.modifiedBy = authUser.user.userId;
      this.props.updateHomeSlider(authUser.token, inputJSON);
    } else {
      inputJSON.createdBy = authUser.user.userId;
      inputJSON.modifiedBy = authUser.user.userId;
      this.props.addHomeSlider(authUser.token, inputJSON);
    }
    this.setState({
      uploading: false
    }, () => {
      this.props.history.goBack();
    })
  }

  onTutorialTypeSelect(value) {
    this.setState({
      selected_type: value
    })
  }

  handleCancel = () => this.setState({ previewVisible: false });

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  beforeUpload = file => {
    this.setState(state => ({
      fileList: [...state.fileList, file],
    }));
    return false;
  }

  onRemove = file => {
    this.setState(state => {
      const index = state.fileList.indexOf(file);
      const newFileList = state.fileList.slice();
      newFileList.splice(index, 1);
      return {
        fileList: newFileList,
      };
    });
  }

  render() {
    const { loader } = this.props.homeSlider;
    const { editId, types, selected_type, uploading, previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Auxiliary>
        <Row className="margin-bottom">
          <Col>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/home/dashboard" className="gx-link">
                  Dashboard
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/home-slider/list" className="gx-link">
                  Home Sliders
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Add</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <PageHeader title={editId ? "Edit Home Slider" : "Add Home Slider"} />
        <Row className="row-margin2">
          <Col>
            {loader || uploading ?
              <div className="gx-loader-view">
                <CircularProgress />
              </div> :
              <Card>
                <Form
                  name="homeSliderForm"
                  onFinish={this.onFinish}
                  layout="vertical"
                  ref={this.formRef}
                >

                  <FormItem label="Name" rules={[{ required: true, message: 'Please enter name.' }]} name="name">
                    <Input placeholder="Name" />
                  </FormItem>

                  <FormItem label="Slide Type" name="type" rules={[{ required: true, message: 'Please select slide type.' }]}>
                    <Select placeholder="Select Slide Type" onSelect={(value) => this.onTutorialTypeSelect(value)}>
                      {types.map(item => (
                        <Option key={item.name}>{item.name}</Option>
                      ))}
                    </Select>
                  </FormItem>

                  <FormItem label="Sequence" rules={[{ required: true, message: 'Please enter slide sequence.' }]} name="seq">
                    <InputNumber placeholder="Sequence" style={{ width: '100%' }} />
                  </FormItem>

                  {selected_type === 'Video' && (
                    <FormItem label="Slide URL" name="slideUrl">
                      <Input placeholder="Slide URL" />
                    </FormItem>
                  )}

                  {selected_type === 'Picture' && (
                    <Upload
                      listType="picture-card"
                      onPreview={this.handlePreview}
                      beforeUpload={this.beforeUpload}
                      onRemove={this.onRemove}
                      accept="image/png, image/jpeg, image/jpg"
                    >
                      {fileList.length > 0 ? null : uploadButton}
                    </Upload>
                  )}

                  <FormItem>
                    <Button loading={loader} className="gx-mb-0" type="primary" htmlType="submit">
                      {editId ? "Update" : "Submit"}
                    </Button>
                  </FormItem>
                </Form>
              </Card>
            }
          </Col>
        </Row>

        <Modal
          visible={previewVisible}
          title={null}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt={"Background Cover"} style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </Auxiliary>
    );
  }
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    homeSlider: state.homeSlider
  }
}

function mapDispathToProps(dispatch) {
  return bindActionCreators({ addHomeSlider, updateHomeSlider, resetHomeSlider }, dispatch);
}

export default connect(mapStateToProps, mapDispathToProps)(AddHomeSlider);
